<template>
    <FormField name="builder" :label="$t(labelText)" :label-width="labelWidth">
        <CustomSelect
            v-model="value"
            :options="options"
            view-label="name"
            emit-prop="name"
            :form-value-text="({ name }) => name"
            :disabled="disabled"
            width="100%"
            placeholder=" "
        />
    </FormField>
</template>
<script>
import { CustomSelect, FormField } from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'BuildersSelect',
    components: {
        CustomSelect,
        FormField
    },
    props: {
        modelValue: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            default: () => []
        },
        labelText: {
            type: String,
            default: 'booksBuilds.edit.builderLabel'
        },
        labelWidth: {
            type: String,
            default: '200px'
        }
    },
    emits: ['update:modelValue'],
    computed: {
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    }
};
</script>
